import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiSignInSubmitOutput } from '../../../../models/enrollment/multi/return-sign-in'

export const submitEnrollmentMultiSignInDataMock: EnrollmentMultiSignInSubmitOutput = {
  nextStep: 'VERIFY_EMAIL',
  error: null,
}

export const mockSubmitEnrollmentMultiSignInData = graphql.mutation('submitEnrollmentMultiSignInData', () => {
  return HttpResponse.json({ data: { enterApplication: submitEnrollmentMultiSignInDataMock } })
})

export const mockEnrollmentMultiSignIn = [mockSubmitEnrollmentMultiSignInData]
